export default __webpack_public_path__ + "static/media/FAQ_11_2.2f8dce22.png";